import React, { type PropsWithChildren, type ReactElement } from 'react';
import { CallToActionButton } from '@finn-no/troika-react-buttons';

export interface EditPanelProps {
    preview: ReactElement;
    className?: string;
}

export const EditPanel: React.FC<PropsWithChildren<EditPanelProps>> = ({ preview, children, className = '' }) => {
    const [expanded, setExpanded] = React.useState(false);

    return (
        <div className={`panel panel--info u-position-relative u-ma0 u-mb4 ${className}`} data-testid="editPanel">
            <div className={expanded ? 'u-display-none' : 'u-hide-gt768'} data-testid="editPanel-preview">
                <button type="button" id="editButton" aria-label="Åpne Redigering" onClick={(): void => setExpanded(true)} />
                {preview}
            </div>
            <div className={!expanded ? 'u-hide-lt768' : 'edit-panel'} data-testid="editPanel-content">
                {children}
                <CallToActionButton id="closeLinkButton" className="u-hide-gt768 u-pa4 u-size1of1" onClick={(): void => setExpanded(false)}>
                    Lukk
                </CallToActionButton>
            </div>
        </div>
    );
};
